import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";

const PrivateRoute = (): JSX.Element | null => {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  keycloak
    .updateToken(5)
    .then((refreshed: boolean) => {
      if (refreshed) {
        // eslint-disable-next-line no-console
        console.log("Token was successfully refreshed");
      } else {
        console.warn("Token is still valid");
      }
    })
    .catch(() => {
      console.error("Failed to refresh the token, or the session has expired");
    });
  useEffect(() => {
    if (!keycloak.authenticated) {
      navigate("/login");
    }
  }, [keycloak, navigate]);

  return <div />;
};

export default PrivateRoute;
